import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Glyph({ ring = "currentColor", needle = "var(--vellus-lagoa)", tail, }) {
    const tailColor = tail ?? `color-mix(in srgb, ${needle} 38%, transparent)`;
    return (_jsxs("svg", { viewBox: "0 0 100 100", width: "100%", height: "100%", fill: "none", "aria-hidden": "true", children: [_jsx("circle", { cx: 50, cy: 50, r: 39, stroke: ring, strokeWidth: 5, opacity: 0.9 }), [
                [50, 7, 50, 15],
                [93, 50, 85, 50],
                [50, 93, 50, 85],
                [7, 50, 15, 50],
            ].map(([x1, y1, x2, y2], i) => (_jsx("line", { x1: x1, y1: y1, x2: x2, y2: y2, stroke: ring, strokeWidth: 4, strokeLinecap: "round", opacity: 0.55 }, i))), _jsx("path", { d: "M34.4 65.6 L54.9 54.9 L45.1 45.1 Z", fill: tailColor }), _jsx("path", { d: "M68.4 31.6 L54.9 54.9 L45.1 45.1 Z", fill: needle }), _jsx("circle", { cx: 50, cy: 50, r: 4.4, fill: ring }), _jsx("circle", { cx: 50, cy: 50, r: 1.7, fill: needle })] }));
}
/**
 * Marca Azim — bússola de azimute (agulha apontando NE).
 * Variante "tile" = quadrado branco com borda Marinho (uso em sidebar/avatar).
 * Variante "plain" = glifo sem fundo (uso em contextos coloridos).
 * Logo sempre via componente — nunca SVG/PNG embutido diretamente em tela.
 */
export function AzimMark({ size = 28, variant = "tile", radius, style = {} }) {
    if (variant === "plain") {
        return (_jsx("span", { style: {
                display: "inline-flex",
                width: size,
                height: size,
                color: "var(--fg-1)",
                ...style,
            }, children: _jsx(Glyph, { ring: "currentColor", needle: "var(--vellus-lagoa)" }) }));
    }
    const rad = radius ?? Math.round(size * 0.28);
    return (_jsx("span", { style: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: size,
            height: size,
            borderRadius: rad,
            background: "#ffffff",
            boxShadow: "inset 0 0 0 1.5px var(--vellus-marinho)",
            ...style,
        }, children: _jsx("span", { style: { width: "68%", height: "68%", display: "block" }, children: _jsx(Glyph, { ring: "var(--vellus-marinho)", needle: "var(--vellus-lagoa)", tail: "rgba(27,29,54,0.32)" }) }) }));
}
/**
 * Wordmark Azim — marca + "Azim" + byline opcional.
 * Parametrizável: sempre via componente, nunca SVG/PNG fixo em tela.
 */
export function AzimWordmark({ size = 22, variant = "tile", byline = false, color = "var(--fg-1)", style = {}, }) {
    const markSize = Math.round(size * 1.5);
    return (_jsxs("span", { style: {
            display: "inline-flex",
            alignItems: "center",
            gap: Math.round(size * 0.5),
            ...style,
        }, children: [_jsx(AzimMark, { size: markSize, variant: variant }), _jsxs("span", { style: { display: "inline-flex", flexDirection: "column", lineHeight: 1 }, children: [_jsx("span", { style: {
                            fontFamily: "var(--font-display)",
                            fontWeight: 700,
                            fontSize: size,
                            letterSpacing: "-0.02em",
                            color,
                        }, children: "Azim" }), byline && (_jsx("span", { style: {
                            fontSize: Math.max(9, size * 0.36),
                            fontWeight: 500,
                            letterSpacing: "0.14em",
                            textTransform: "uppercase",
                            color: "var(--fg-3)",
                            marginTop: 3,
                        }, children: "by Vellus" }))] })] }));
}
/**
 * Glifo Azim exposto para usos avançados (ex.: animações).
 */
export function AzimGlyph({ ring, needle, tail }) {
    return (_jsx(Glyph, { ...(ring !== undefined ? { ring } : {}), ...(needle !== undefined ? { needle } : {}), ...(tail !== undefined ? { tail } : {}) }));
}
//# sourceMappingURL=AzimMark.js.map